"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _audioVideoDidStartHandler = require("./audioVideoDidStartHandler");
Object.keys(_audioVideoDidStartHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _audioVideoDidStartHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _audioVideoDidStartHandler[key];
    }
  });
});